import routes from 'actions/routes';
import { generateReadOneActionCreator } from 'actions/crudActionCreators';
import ACTION_NAMES from 'actions/ACTION_NAMES';

export default {
    readLeads: generateReadOneActionCreator(routes.API_LEADS_TAB, ACTION_NAMES.LEADS_TAB)
};
